import React from 'react';

import './DemoConsole.css';

interface Props {
  isShow: boolean | undefined;
  messages: string[];
}

export default function DemoConsole(props: Props) {
  const { isShow, messages } = props;

  if (!isShow) {
    return null;
  }

  return (
    <div className="demo-console">
      <div className="demo-console-title">Demo console</div>
      <div className="demo-console-message">
        {messages.map((message, index) => (
          <div key={message + index} dangerouslySetInnerHTML={{ __html: message }} />
        ))}
      </div>
    </div>
  );
}
